import { IComponentOptions } from "angular";
import { ContactBookFormController } from "./controller";

export const vsComponentName = "contactBookForm";

export const ContactBookFormComponentOptions: IComponentOptions =
  {
    controller: ContactBookFormController,
    template: require("!html-loader!./index.html").default,
    controllerAs: "stateController",
    bindings: {
      contactBook:"<"    
    },
  };
